import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Table, Button, Card, Popconfirm, Input, Icon } from 'antd';

export class AprovarCadastro extends Component {
  static propTypes = {
    usuarios: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    searchText: '',
    selectedRowKeys: [],
  };

  componentDidMount = () => {
    this.buscarRegistros();
  };

  buscarRegistros = () => {
    this.props.actions.buscarPendenteAprovacao(action => {
      // if (action === 'USUARIOS_BUSCAR_PENDENTE_APROVACAO_SUCCESS') {
      //   const { registros } = this.props.usuarios;
      //   var filtros = {
      //     emails: [],
      //   };
      //   registros.map(item => {
      //     filtros.emails.push({ text: item.email, value: item.email });
      //     filtros.nomes.push({ text: item.nomeCompleto, value: item.nomeCompleto });
      //   });
      //   this.setState({ filtrosGrid: filtros });
      // }
    });
  };
  onSelectChange = selectedRowKeys => {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  aprovarUsuario = usuario => {
    console.log('Usuario ', usuario);
    this.props.actions.aprovarCadastro(usuario);
  };

  deleteConfirm = registro => {
    this.props.actions.reprovarCadastro(registro);
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={``}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Pesquisar
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Limpar
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    // render: (text) => (
    //   <Highlighter
    //     highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
    //     searchWords={[this.state.searchText]}
    //     autoEscape
    //     textToHighlight={text.toString()}
    //   />
    // ),
  });
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const { usuarios } = this.props;
    // const rowSelection = {
    //   selectedRowKeys: this.state.selectedRowKeys,
    //   onChange: this.onSelectChange,
    // };
    const colunas = [
      {
        title: 'Nome',
        dataIndex: 'nomeCompleto',
        key: 'nomeCompleto',
        ...this.getColumnSearchProps('nomeCompleto'),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: (a, b) => {
          let textoA = a.email.toLowerCase(),
            textoB = b.email.toLowerCase();

          if (textoA < textoB) return -1;

          if (textoA > textoB) return 1;

          return 0;
        },
        ...this.getColumnSearchProps('email'),
      },
      {
        title: '',
        dataIndex: '',
        key: 'x',
        render: (text, record) => (
          <span>
            <Button
              size="small"
              onClick={() => this.aprovarUsuario(record)}
              loading={this.props.usuarios.aprovarCadastroPending}
            >
              Aprovar
            </Button>{' '}
            <Popconfirm
              title="Confirma reprovação do registro?"
              okText="Sim"
              cancelText="Não"
              onConfirm={() => this.deleteConfirm(record)}
            >
              <Button size="small" type="danger" icon="delete" loading={this.props.deletarPending}>
                Reprovar
              </Button>
            </Popconfirm>
          </span>
        ),
      },
    ];

    return (
      <div className="usuarios-aprovar-cadastro">
        <Card
          title="Usuários pendente aprovação de registro"
          extra={
            <Button
              type="primary"
              onClick={this.buscarRegistros}
              loading={usuarios.buscarPendenteAprovacaoPending}
            >
              Atualizar
            </Button>
          }
        >
          <Table
            columns={colunas}
            dataSource={usuarios.registros}
            // rowSelection={rowSelection}
            loading={usuarios.buscarPendenteAprovacaoPending}
          />
        </Card>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    usuarios: state.usuarios,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AprovarCadastro);



// WEBPACK FOOTER //
// ./src/features/usuarios/AprovarCadastro.js